import { render, staticRenderFns } from "./ValidateBlockWrapper.vue?vue&type=template&id=9d0135d2"
import script from "./ValidateBlockWrapper.vue?vue&type=script&lang=js"
export * from "./ValidateBlockWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports